import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { 
	UNAUTHENTICATED_ENTRY, 
	REDIRECT_URL_KEY,
	WORKSPACE_BASE_PATH,
	WORKSPACE_ENTRY,
} from 'configs/AppConfig'

const ProtectedRoute = () => {
	
	const { token, user } = useSelector(state => state.auth)
	const location = useLocation()

	if (!token) {
		return <Navigate to={`${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
	}

	// Notes/workspace-only users are locked to the Workspace Editor area.
	const isWorkspaceOnly = user?.workspaceOnly
		|| JSON.parse(localStorage.getItem('auth_user') || 'null')?.workspaceOnly;
	if (isWorkspaceOnly && !location.pathname.startsWith(WORKSPACE_BASE_PATH)) {
		return <Navigate to={WORKSPACE_ENTRY} replace />;
	}

	return <Outlet />
}

export default ProtectedRoute